<template>
  <div class="zhuli">
    <el-select
      v-model="selectedValue"
      multiple
      size="small"
      @change="handleChangeAssist"
    >
      <el-option
        v-for="item in assistMembers"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </div>
</template>
<script>
import pathReq from '@/api/pathlist'

export default {
  props: {
    value: { type: String, default: null },
    moduleCode: { type: String, default: '' }
  },
  data() {
    return {
      assistMembers: [],
      selectedValue: []
    }
  },
  watch: {
    value(n, o) {
      this.setSelectValue()
    }
  },
  mounted() {
  },
  created() {
  },
  activated() {
    this.setSelectValue()
    this.getDataList()
  },
  methods: {
    setSelectValue() {
      if (this.value) {
        this.selectedValue = this.value.split(',')
      } else {
        this.selectedValue = []
      }
    },
    getDataList() {
      const that = this
      const path = '/api/services/app/Com/GetAssistMember?ModuleCode=' + this.moduleCode
      pathReq.getNoParams(path).then((res) => {
        if (res.data.success) {
          that.assistMembers = res.data.result.assistMembers
        }
      })
    },
    handleChangeAssist() {
      this.$emit('input', this.selectedValue.join(','))
    }
  }
}
</script>
